/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentPlans } from 'app/entities/treatment-plan/treatment-plan.reducer';
import { getEntities as getPhysioTherapists } from 'app/entities/physio-therapist/physio-therapist.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { createEntity, getEntity, reset, updateEntity } from './physio-order.reducer';

export const PhysioOrderUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentPlans = useAppSelector(state => state.treatmentPlan.entities);
  const physioTherapists = useAppSelector(state => state.physioTherapist.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const physioOrderEntity = useAppSelector(state => state.physioOrder.entity);
  const loading = useAppSelector(state => state.physioOrder.loading);
  const updating = useAppSelector(state => state.physioOrder.updating);
  const updateSuccess = useAppSelector(state => state.physioOrder.updateSuccess);

  const handleClose = () => {
    navigate(`/physio-order${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentPlans({}));
    dispatch(getPhysioTherapists({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...physioOrderEntity,
      ...values,
      treatmentPlan: treatmentPlans.find(it => it.id.toString() === values.treatmentPlan?.toString()),
      fulfilledBy: physioTherapists.find(it => it.id.toString() === values.fulfilledBy?.toString()),
      createdBy: doctors.find(it => it.id.toString() === values.createdBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...physioOrderEntity,
          treatmentPlan: physioOrderEntity?.treatmentPlan?.id,
          fulfilledBy: physioOrderEntity?.fulfilledBy?.id,
          createdBy: physioOrderEntity?.createdBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.physioOrder.home.createOrEditLabel" data-cy="PhysioOrderCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.physioOrder.home.createOrEditLabel">Create or edit a PhysioOrder</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="physio-order-id"
                  label={translate('tinyMedicRestApp.physioOrder.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.physioOrder.microSec')}
                id="physio-order-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.physioOrder.timestampentry')}
                id="physio-order-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.physioOrder.lastupdated')}
                id="physio-order-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.physioOrder.cursor')}
                id="physio-order-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.physioOrder.active')}
                id="physio-order-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.physioOrder.recomendation')}
                id="physio-order-recomendation"
                name="recomendation"
                data-cy="recomendation"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.physioOrder.orderStatus')}
                id="physio-order-orderStatus"
                name="orderStatus"
                data-cy="orderStatus"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                id="physio-order-treatmentPlan"
                name="treatmentPlan"
                data-cy="treatmentPlan"
                label={translate('tinyMedicRestApp.physioOrder.treatmentPlan')}
                type="select"
                required
              >
                <option value="" key="0" />
                {treatmentPlans
                  ? treatmentPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="physio-order-fulfilledBy"
                name="fulfilledBy"
                data-cy="fulfilledBy"
                label={translate('tinyMedicRestApp.physioOrder.fulfilledBy')}
                type="select"
              >
                <option value="" key="0" />
                {physioTherapists
                  ? physioTherapists.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="physio-order-createdBy"
                name="createdBy"
                data-cy="createdBy"
                label={translate('tinyMedicRestApp.physioOrder.createdBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/physio-order" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PhysioOrderUpdate;
